import { useState } from "react";
import { Gift, MessageSquare, X } from "lucide-react";

export const WelcomeBonusBanner = ({ user, config, onStart }) => {
  const key = `rathri_welcome_bonus_${user?.id}`;
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(key) === "1");
  if (!user?.welcome_bonus_granted || dismissed) return null;
  const inr = config?.welcome_bonus?.inr ?? 10;
  const days = config?.welcome_bonus?.valid_days ?? 30;
  const chatRate = (config?.chat_coins ?? 12) / 6;
  const dismiss = () => { localStorage.setItem(key, "1"); setDismissed(true); };

  return (
    <section data-testid="welcome-bonus-banner" className="rounded-3xl border border-emerald-300 bg-emerald-50 px-4 py-4 flex flex-wrap items-center gap-3 fade-up">
      <span className="w-11 h-11 rounded-2xl bg-emerald-500 text-white inline-flex items-center justify-center shrink-0 shadow-lg shadow-emerald-500/25"><Gift size={20} /></span>
      <div className="flex-1 min-w-[190px]">
        <p className="text-sm font-extrabold text-emerald-900">Welcome Offer — <span className="font-num">₹{inr}</span> ബോണസ് ബാലൻസ് സൗജന്യം</p>
        <p className="text-[11px] leading-relaxed text-emerald-800">ഏതു staff-നോടും chat ചെയ്യാം — ഈ ₹{inr} ബോണസ് chat-ന് മാത്രം ഉപയോഗിക്കാം (ഓരോ message-നും <span className="font-num font-bold">₹{chatRate}</span>); {days} ദിവസം valid ആണ്.</p>
      </div>
      <button type="button" data-testid="welcome-bonus-start-button" onClick={onStart} className="h-9 px-4 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold inline-flex items-center gap-1.5 transition-colors"><MessageSquare size={13} /> ചാറ്റ് തുടങ്ങുക</button>
      <button type="button" data-testid="welcome-bonus-dismiss-button" onClick={dismiss} aria-label="Dismiss welcome offer" className="w-8 h-8 rounded-full bg-white/80 text-emerald-700 inline-flex items-center justify-center hover:bg-white transition-colors"><X size={14} /></button>
    </section>
  );
};
